import { render } from "./AcreCookieConsent.vue?vue&type=template&id=1b06ae35&ts=true"
import script from "./AcreCookieConsent.vue?vue&type=script&lang=ts"
export * from "./AcreCookieConsent.vue?vue&type=script&lang=ts"

import _style_0 from "./AcreCookieConsent.vue?vue&type=style&index=0&id=1b06ae35&inline&lang=sass"

import exportComponent from "/Users/eric/Code/acre-components/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__